import { z } from "zod";
import { gql } from "graphql-request";
import { Image, ImageFragment } from "../image";
import { Sys, SysFragment } from "../sys";

export const EsportRewatchMatchEntry = z.object({
  __typename: z.literal("EsportRewatchMatchEntry"),
  sys: Sys,

  playerOneName: z.string().nullable(),
  playerOneScore: z.number().nullable(),

  playerTwoName: z.string().nullable(),
  playerTwoScore: z.number().nullable(),

  matchUrl: z.string().nullable(),

  matchThumbnail: Image.nullable(),
  playerOneImage: Image.nullable(),
  playerTwoImage: Image.nullable(),

  matchThumbnailEn: Image.nullable(),
  playerOneImageEn: Image.nullable(),
  playerTwoImageEn: Image.nullable(),
});

export const EsportRewatchMatchEntryFragment = gql`
  fragment EsportRewatchMatchEntryFragment on EsportRewatchMatchEntry {
    sys {
      ...SysFragment
    }

    playerOneName
    playerOneScore
    playerTwoScore
    playerTwoName
    matchUrl

    playerOneImage {
      ...ImageFragment
    }

    playerTwoImage {
      ...ImageFragment
    }

    matchThumbnail {
      ...ImageFragment
    }

    playerOneImageEn: playerOneImage(locale: "en") {
      ...ImageFragment
    }

    playerTwoImageEn: playerTwoImage(locale: "en") {
      ...ImageFragment
    }

    matchThumbnailEn: matchThumbnail(locale: "en") {
      ...ImageFragment
    }
  }

  ${ImageFragment}
  ${SysFragment}
`;
